module.exports = __webpack_public_path__ + "static/img/zj-rigth.5da45bf0.png";